import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import { setIntendedReferralId } from '../store/slices/intendedInfoSlice';

import { dateStringForDateTime } from '../utils/utils';

import DA from '../store/ReduxAccess';

import referralAssocGroupStyles from '../assets/jss/crm/components/referralAssocGroupStyles';
import ReduxLoader from '../store/ReduxLoader';

class ReferralSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
    };
  }

  launchFullReferralPage(referral) {
    const continuation = () => {
      this.props.setIntendedReferralId(referral.referralId);
      this.setState({ redirect: 'referral' });
    };
    ReduxLoader.loadReferral(referral.referralId, continuation);
  }

  getReferreeName(referral) {
    if (referral.referreeName) {
      return referral.referreeName;
    } else {
      const referree = DA.getPersonById(referral.referreeId);
      return referree ? referree.preferredFullName : '';
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    const { classes, referral } = this.props;
    const referrer = DA.getPersonById(referral.referrerId);
    const referrerName = referrer ? referrer.preferredFullName : '';
    const referreeName = this.getReferreeName(referral);
    return (
      <div
        className={cx(classes.entitySummary, classes.entitySummary_contact)}
        onClick={() => this.launchFullReferralPage(referral)}
      >
        <div className={cx(classes.entitySummary_detail, classes.ac_h5, classes.u_ellipsis)}>
          {dateStringForDateTime(referral.date)}
        </div>
        <div className={cx(classes.entitySummary_title, classes.u_cursorPointer, classes.u_ellipsis, classes.ac_h4)}>
          {referreeName}
        </div>
        {referrer && (
          <div className={cx(classes.entitySummary_subtitle, classes.u_ellipsis, classes.ac_h5)}>
            <span className={classes.entitySummary_subtitleName}>Referred By:&nbsp;</span>
            <span className={classes.entitySummary_subtitleName}>{referrerName}</span>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const actionProducers = {
  setIntendedReferralId,
};

export default connect(mapStateToProps, actionProducers)(withStyles(referralAssocGroupStyles)(ReferralSummary));
